// extracted by mini-css-extract-plugin
export var fullWidthButton = "_g1-0";